import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Register from "./pages/auth/Register";
import Login from "./pages/auth/login";
import DashboardLayout from "./pages/components/DashboardLayout";
import ProtectedRoute from "./pages/auth/ProtectedRoute";
import Logout from "./pages/auth/Logout";
import PublicRoute from "./pages/auth/PublicRoute";
import Dashboard from "./pages/users/Dashboard";
import Transaction from "./pages/users/Transaction";
import NotFound from "./pages/components/NotFound";
import Paymentlink from "./pages/users/payment_link";
import SenTransaction from "./pages/users/send_transactions";
import Settelment from "./pages/users/Settelements";
import DeveloperSection from "./pages/users/developer_section";
import LoginAs from "./pages/auth/admin_login";
import PaymentPage from "./pages/users/Paymentpage";

// ⬇️ Import your Admin Dashboard pages
// import AdminDashboard from "./pages/admin/AdminDashboard"; 
// import AdminLayout from "./pages/admin/AdminLayout";

function App() {
  return (
    <Router>
      <Routes>
        {/* Auth Routes */}
        <Route path="/login_by_admin" element={<PublicRoute><LoginAs /></PublicRoute>} />

        
        <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
        <Route path="/payment/:id" element={<PaymentPage />} />
        {/* User Protected Routes */}
        <Route
          element={
            <ProtectedRoute role="user">
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/payment_link" element={<Paymentlink />} />
          <Route path="/Receive_transaction" element={<Transaction />} />
          <Route path="/Send_transaction" element={<SenTransaction />} />
          <Route path="/Settelment" element={<Settelment />} />
          <Route path="/developer_section" element={<DeveloperSection />} />
        </Route>

        {/* Admin Protected Routes */}
        <Route
          element={
            <ProtectedRoute role="admin">
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/admin/dashboard" element={<Dashboard />} />
          {/* add more admin-only routes here */}
        </Route>

        {/* Logout */}
        <Route path="/logout" element={<Logout />} />

        {/* Default Route → check role and redirect */}
        <Route
          path="/"
          element={
            localStorage.getItem("account_type") === "admin"
              ? <Navigate to="/admin/dashboard" replace />
              : localStorage.getItem("account_type") === "user"
              ? <Navigate to="/dashboard" replace />
              : <Login />
          }
        />

        {/* Catch-all 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
